import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { HitStatusType } from './hit-status-type.interface';

export class HitStatusTypeService {
   async getHitStatusTypes(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<HitStatusType>>>('/hit-status-types', {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }

   async getHitStatusType() {
      throw Error('Method not implemented');
   }

   async postHitStatusType() {
      throw Error('Method not implemented');
   }

   async putHitStatusType() {
      throw Error('Method not implemented');
   }

   async deleteHitStatusType() {
      throw Error('Method not implemented');
   }
}
